import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { homeHowItWork } from "../../store/actions/homeContentAction";
import { unescapeHTML } from "../common/Common";

const WorkStart = () => {
  const dispatch = useDispatch();
  const data_home = useSelector(
    (state) => state.data_home_how_it_work
  );
  const { loading } = data_home;

  useEffect( () => {
    loading && dispatch(homeHowItWork())
  }, [dispatch,loading]);
  return (
    <>
      {!loading && data_home.data.isActive === 1 && (
        <div
          dangerouslySetInnerHTML={{
            __html: unescapeHTML(data_home.data.blockContent),
          }}
        ></div>
      )}
    </>
  );
};

export default WorkStart;
